const AydinlatmaMetni = (props) => {
  return (
    <>
      <div
        className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
        id="aydinlatmaMetni"
        tabIndex="-1"
        aria-labelledby="aydinlatmaMetniLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg relative w-auto pointer-events-none">
          <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="modal-body relative p-4 space-y-4">
              <h4 className="text-gray-800 font-semibold">
                KİŞİSEL VERİLERİN İŞLENMESİNE İLİŞKİN ÇALIŞAN ADAYI AYDINLATMA
                METNİ
              </h4>
              <div className="w-100 flex flex-row text-gray-900">
                <div>
                  <h5 className="font-semibold text-xs">Veri Sorumlusu: </h5>
                </div>
                <div className="flex flex-col pl-3">
                  <p className="font-semibold text-xs">Ray Sigorta A.Ş.</p>
                  <p className="text-xs">
                    Cumhuriyet Mah. Haydar Aliyev Cad. No: 28 Tarabya 34457
                    Sarıyer/ İstanbul
                  </p>
                </div>
              </div>

              <div className="space-y-3">
                <p className="text-gray-900 text-xs">
                  <span className="font-semibold">
                    Ray Sigorta A.Ş. (“Ray Sigorta”)
                  </span>{" "}
                  olarak; 6698 Sayılı Kişisel Verilerin Korunması Kanunu
                  <span className="font-semibold">(“KVKK”)</span> ve ilgili
                  mevzuat kapsamında Ray Sigorta’ya yapmış olduğunuz iş
                  başvurunuz kapsamında kişisel verilerinizi toplamakta,
                  işlemekte ve saklamaktayız.
                </p>
                <ul className="list-decimal text-xs text-gray-900 space-y-3">
                  <li className="font-semibold ml-10">
                    Hangi Kişisel Verileriniz İşlenmekte ve Kişisel
                    Verilerinizin İşlenme Amaçları Nelerdir?
                  </li>

                  <p className="text-xs text-gray-900">
                    Faaliyetlerimiz ve istihdam amaçlarımız kapsamında siz{" "}
                    <span className="font-semibold">çalışan adaylarımızın</span>{" "}
                    aşağıda yer alan verilerini toplamaktayız.
                  </p>

                  {/** Kişisel Bilgiler */}
                  <div className="flex flex-col text-xs">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="py-2 min-w-full sm:px-6 lg:px-8">
                        <div>
                          <table className="min-w-full border">
                            <thead className="border-b">
                              <tr>
                                <th
                                  colSpan="3"
                                  scope="col"
                                  className="text-xs text-white px-6 py-4 border-r text-left font-bold bg-blue-800"
                                >
                                  Kimlik Bilgileri
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  İşlenen Kişisel Veriler
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  <ul className="list-disc pl-3">
                                    <li>Ad-Soyad, </li>
                                    <li>TCKN,</li>
                                    <li>Cinsiyet,</li>
                                    <li>Uyruk,</li>
                                    <li>Doğum Tarihi,</li>
                                    <li>Fotoğraf,</li>
                                    <li>Ehliyet Bilgisi</li>
                                  </ul>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Veri İşleme Amaçları
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  Çalışan Adayı Seçme ve Yerleştirme
                                  Süreçlerinin Yürütülmesi, Çalışan Adaylarının
                                  Başvuru Süreçlerinin Yürütülmesi, İletişim
                                  Faaliyetlerinin Yürütülmesi, İnsan Kaynakları
                                  Süreçlerinin Planlanması
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verilerin İşlenmesinin Hukuki
                                  Sebepleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  <p>
                                    Kişisel verileriniz, Ray Sigorta tarafından
                                    yukarıda sayılan amaçların
                                    gerçekleştirilmesi doğrultusunda, KVKK’nın
                                    5’inci maddesinde belirtilen;
                                  </p>
                                  <ul className="list-disc pl-6">
                                    <li>
                                      Bir sözleşmenin kurulması veya ifasıyla
                                      doğrudan doğruya ilgili olması kaydıyla,
                                      sözleşmenin taraflarına ait kişisel
                                      verilerin işlenmesinin gerekli olması,
                                    </li>
                                    <li>
                                      İlgili kişinin temel hak ve özgürlüklerine
                                      zarar vermemek kaydıyla, veri sorumlusunun
                                      meşru menfaatleri için veri işlenmesinin
                                      zorunlu olması
                                    </li>
                                  </ul>
                                  <p>
                                    hukuki sebeplerine dayanılarak
                                    işlenmektedir.
                                  </p>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verileri Toplama Yöntemleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  Yukarıda kategoriler halinde belirtilen
                                  kişisel verileriniz; elektronik sistemler
                                  vasıtasıyla toplanmaktadır.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/** İletişim Bilgileri */}
                  <div className="flex flex-col text-xs">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="py-2 min-w-full sm:px-6 lg:px-8">
                        <div>
                          <table className="min-w-full border">
                            <thead className="border-b">
                              <tr>
                                <th
                                  colSpan="3"
                                  scope="col"
                                  className="text-xs text-white px-6 py-4 border-r text-left font-bold bg-blue-800"
                                >
                                  İletişim Bilgileri
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  İşlenen Kişisel Veriler
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  <ul className="list-disc pl-3">
                                    <li>Adres,</li>
                                    <li>Telefon Numarası,</li>
                                    <li>E-Posta Adresi</li>
                                  </ul>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Veri İşleme Amaçları
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  Çalışan Adayı Seçme ve Yerleştirme
                                  Süreçlerinin Yürütülmesi, Çalışan Adaylarının
                                  Başvuru Süreçlerinin Yürütülmesi, İletişim
                                  Faaliyetlerinin Yürütülmesi, İnsan Kaynakları
                                  Süreçlerinin Planlanması
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verilerin İşlenmesinin Hukuki
                                  Sebepleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  <p>
                                    Kişisel verileriniz, Ray Sigorta tarafından
                                    yukarıda sayılan amaçların
                                    gerçekleştirilmesi doğrultusunda, KVKK’nın
                                    5’inci maddesinde belirtilen;
                                  </p>
                                  <ul className="list-disc pl-6">
                                    <li>
                                      Bir sözleşmenin kurulması veya ifasıyla
                                      doğrudan doğruya ilgili olması kaydıyla,
                                      sözleşmenin taraflarına ait kişisel
                                      verilerin işlenmesinin gerekli olması,
                                    </li>
                                    <li>
                                      İlgili kişinin temel hak ve özgürlüklerine
                                      zarar vermemek kaydıyla, veri sorumlusunun
                                      meşru menfaatleri için veri işlenmesinin
                                      zorunlu olması
                                    </li>
                                  </ul>
                                  <p>
                                    {" "}
                                    hukuki sebeplerine dayanılarak
                                    işlenmektedir.
                                  </p>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verileri Toplama Yöntemleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  Yukarıda kategoriler halinde belirtilen
                                  kişisel verileriniz; elektronik sistemler
                                  vasıtasıyla toplanmaktadır.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/** Özlük Bilgileri */}
                  <div className="flex flex-col text-xs">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="py-2 min-w-full sm:px-6 lg:px-8">
                        <div>
                          <table className="min-w-full border">
                            <thead className="border-b">
                              <tr>
                                <th
                                  colSpan="3"
                                  scope="col"
                                  className="text-xs text-white px-6 py-4 border-r text-left font-bold bg-blue-800"
                                >
                                  Özlük Bilgileri
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  İşlenen Kişisel Veriler
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  <ul className="list-disc pl-3">
                                    <li>Unvan,</li>
                                    <li>Fotoğraf, </li>
                                    <li>Eğitim Durumu,</li>
                                    <li>Referans Bilgileri,</li>
                                    <li>Çalışma Geçmişi ve Detayları,</li>
                                    <li>Başvurulan Pozisyon Bilgisi,</li>
                                    <li>Maaş Beklentisi Bilgisi,</li>
                                    <li>İşe Başlama Tarihi,</li>
                                    <li>İşten Ayrılış Tarihi,</li>
                                    <li>Askerlik Durum Bilgisi,</li>
                                    <li>Hobiler ve İlgi Alanları</li>
                                  </ul>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Veri İşleme Amaçları
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  Çalışan Adayı Seçme ve Yerleştirme
                                  Süreçlerinin Yürütülmesi, Çalışan Adaylarının
                                  Başvuru Süreçlerinin Yürütülmesi, İletişim
                                  Faaliyetlerinin Yürütülmesi, İnsan Kaynakları
                                  Süreçlerinin Planlanması
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verilerin İşlenmesinin Hukuki
                                  Sebepleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  <p>
                                    Kişisel verileriniz, Ray Sigorta tarafından
                                    yukarıda sayılan amaçların
                                    gerçekleştirilmesi doğrultusunda, KVKK’nın
                                    5’inci maddesinde belirtilen;
                                  </p>
                                  <ul className="list-disc pl-6">
                                    <li>
                                      Bir sözleşmenin kurulması veya ifasıyla
                                      doğrudan doğruya ilgili olması kaydıyla,
                                      sözleşmenin taraflarına ait kişisel
                                      verilerin işlenmesinin gerekli olması,
                                    </li>
                                    <li>
                                      İlgili kişinin temel hak ve özgürlüklerine
                                      zarar vermemek kaydıyla, veri sorumlusunun
                                      meşru menfaatleri için veri işlenmesinin
                                      zorunlu olması
                                    </li>
                                  </ul>
                                  <p>
                                    {" "}
                                    hukuki sebeplerine dayanılarak
                                    işlenmektedir.
                                  </p>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verileri Toplama Yöntemleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  Yukarıda kategoriler halinde belirtilen
                                  kişisel verileriniz; elektronik sistemler
                                  vasıtasıyla toplanmaktadır.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/** Mesleki Deneyim Bilgileri  */}
                  <div className="flex flex-col text-xs">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="py-2 min-w-full sm:px-6 lg:px-8">
                        <div>
                          <table className="min-w-full border">
                            <thead className="border-b">
                              <tr>
                                <th
                                  colSpan="3"
                                  scope="col"
                                  className="text-xs text-white px-6 py-4 border-r text-left font-bold bg-blue-800"
                                >
                                  Mesleki Deneyim Bilgileri
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  İşlenen Kişisel Veriler
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  <ul className="list-disc pl-3">
                                    <li>
                                      Toplam Tecrübe ve İş Deneyimi Bilgisi,{" "}
                                    </li>
                                    <li>Transkript Bilgileri, </li>
                                    <li>Diploma Bilgisi,</li>
                                    <li>Sertifikalar,</li>
                                    <li>Gidilen Kurslar,</li>
                                    <li>Yabancı Dil Bilgisi,</li>
                                    <li>Bilgisayar Kullanım Bilgisi,</li>
                                    <li>Sınav Bilgileri,</li>
                                    <li>Burs Bilgileri</li>
                                  </ul>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Veri İşleme Amaçları
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4  border-r"
                                >
                                  Çalışan Adayı Seçme ve Yerleştirme
                                  Süreçlerinin Yürütülmesi, Çalışan Adaylarının
                                  Başvuru Süreçlerinin Yürütülmesi, İletişim
                                  Faaliyetlerinin Yürütülmesi, İnsan Kaynakları
                                  Süreçlerinin Planlanması
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verilerin İşlenmesinin Hukuki
                                  Sebepleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  <p>
                                    Kişisel verileriniz, Ray Sigorta tarafından
                                    yukarıda sayılan amaçların
                                    gerçekleştirilmesi doğrultusunda, KVKK’nın
                                    5’inci maddesinde belirtilen;
                                  </p>
                                  <ul className="list-disc pl-6">
                                    <li>
                                      Bir sözleşmenin kurulması veya ifasıyla
                                      doğrudan doğruya ilgili olması kaydıyla,
                                      sözleşmenin taraflarına ait kişisel
                                      verilerin işlenmesinin gerekli olması,
                                    </li>
                                    <li>
                                      İlgili kişinin temel hak ve özgürlüklerine
                                      zarar vermemek kaydıyla, veri sorumlusunun
                                      meşru menfaatleri için veri işlenmesinin
                                      zorunlu olması
                                    </li>
                                  </ul>
                                  <p>
                                    {" "}
                                    hukuki sebeplerine dayanılarak
                                    işlenmektedir.
                                  </p>
                                </td>
                              </tr>
                              <tr className="bg-white border-b">
                                <td className="px-6 py-4  text-xs font-semibold text-gray-900 bg-gray-100 border-r w-min">
                                  Kişisel Verileri Toplama Yöntemleri
                                </td>
                                <td
                                  colSpan="2"
                                  className="text-xs text-gray-900 font-light px-6 py-4 border-r"
                                >
                                  Yukarıda kategoriler halinde belirtilen
                                  kişisel verileriniz; elektronik sistemler
                                  vasıtasıyla toplanmaktadır.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <li className="font-semibold ml-10">
                    Kişisel Verileriniz Yurt İçinde Kimlere ve Hangi Amaçlarla
                    Aktarılabilecektir?
                  </li>
                  <p>
                    Kişisel verileriniz, KVKK ve yürürlükte olan mevzuata uygun
                    olarak;
                  </p>
                  <ul className="list-disc ml-10">
                    <li>
                      Yasal düzenlemeler ve tabi olduğumuz mevzuat gereği,
                      mevzuatta açıkça yetkilendirilmiş kişilerle paylaşılır.
                      Ayrıca, kişisel verileriniz, bir mahkeme kararı veya
                      yetkili kılınmış idari mercilerin talebi üzerine,{" "}
                      <span className="font-semibold">
                        Yetkili Kişi veya Kamu Kurum ve Kuruluşları’na
                      </span>{" "}
                      KVKK’nın 5. maddesinin 2. fıkrasının (a) ve (ç) bendi
                      uyarınca aktarabilecektir.
                    </li>
                    <li>
                      Aramızdaki hizmet sözleşmesi kapsamında tedarikçilerden
                      temin edilecek ürün veya hizmetlere ilişkin olarak,
                      çalışan adayı seçme ve yerleştirme süreçlerinin
                      yürütülmesi, çalışan adaylarının başvuru süreçlerinin
                      yürütülmesi, iletişim faaliyetlerinin yürütülmesi, iş
                      faaliyetlerinin yürütülmesi/denetimi, insan kaynakları
                      süreçlerinin planlanması, saklama ve arşiv faaliyetlerinin
                      yürütülmesi, sözleşme süreçlerinin yürütülmesi amaçlarıyla
                      <span className="font-semibold">
                        Tedarikçilerimiz’e
                      </span>{" "}
                      KVKK’nın 5. maddesinin 2. fıkrasının (c) bendi uyarınca
                      aktarabilecektir.
                    </li>
                  </ul>

                  <li className="font-semibold ml-10">
                    Kişisel Verileriniz Ne Kadar Süre ile Saklanır?
                  </li>
                  <p>
                    Kişisel verilerinizin saklama süresi aşağıdaki şekildedir:
                  </p>
                  <ul className="list-disc ml-10">
                    <li>
                      Kanunda veya ilgili mevzuatta verinin saklanması için bir
                      süre belirlenmişse, söz konusu veri en az bu süre kadar
                      saklanmak zorundadır.
                    </li>
                  </ul>
                  <li className="font-semibold ml-10">
                    İlgili Kişi Olarak Haklarınızı Nasıl Kullanabilirsiniz?
                  </li>

                  <p>
                    Kişisel verileriniz ile ilgili başvuru ve taleplerinizi{" "}
                    <span className="underline">dilerseniz</span>{" "}
                    <span className="font-semibold">
                      ‘‘İlgili Kişi Başvuru Formu’’
                    </span>{" "}
                    aracılığıyla;
                  </p>

                  <ul className="list-disc ml-10">
                    <li>
                      Islak imzalı ve kimlik fotokopisi ile{" "}
                      <span className="font-semibold">
                        Cumhuriyet Mahallesi Haydar Aliyev Cadde No: 28
                        Sarıyer/İstanbul
                      </span>{" "}
                      adresine göndererek,
                    </li>
                    <li>
                      Geçerli bir kimlik belgesi ile birlikte Ray{" "}
                      <span className="font-semibolds">Sigorta’</span>ya{" "}
                      <span className="font-semibold">
                        Cumhuriyet Mahallesi Haydar Aliyev Cadde No: 28
                        Sarıyer/İstanbul
                      </span>{" "}
                      adresinden şahsen başvurarak,{" "}
                    </li>
                    <li>
                      Mobil imza veya güvenli elektronik imza ile imzalayıp{" "}
                      <a
                        className="font-semibold text-blue-600 underline"
                        href="mailto:kisiselverikoruma@raysigorta.com.tr"
                      >
                        kisiselverikoruma@raysigorta.com.tr
                      </a>{" "}
                      adresine e-posta gönderilerek,
                    </li>
                    <li>
                      Kayıtlı elektronik posta (KEP) adresi, güvenli elektronik
                      imza ya da mobil imza kullanmak suretiyle{" "}
                      <a
                        href="mailto:raysigorta.kvk@hs03.kep.tr"
                        className="font-semibold "
                      >
                        raysigorta.kvk@hs03.kep.tr
                      </a>{" "}
                      kayıtlı elektronik posta (KEP) adresine göndererek,
                    </li>
                    <li>
                      Ray Sigorta sisteminde kayıtlı olan e-posta adresiniz
                      aracılığıyla{" "}
                      <a
                        className="font-semibold text-blue-600 underline"
                        href="mailto:kisiselverikoruma@raysigorta.com.tr"
                      >
                        kisiselverikoruma@raysigorta.com.tr
                      </a>{" "}
                      adresine e-posta gönderilerek,
                    </li>
                  </ul>

                  <p>
                    Ray Sigorta’ya iletebilirsiniz.
                    <br />
                    <br />
                    Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ
                    uyarınca, İlgili Kişi’nin, başvurusunda isim, soyisim,
                    başvuru yazılı ise imza, T.C. kimlik numarası (başvuruda
                    bulunan kişinin yabancı olması halinde uyruğu, pasaport
                    numarası veya varsa kimlik numarası), tebligata esas
                    yerleşim yeri veya iş yeri adresi, varsa bildirime esas
                    elektronik posta adresi, telefon numarası ve faks numarası
                    ile talep konusuna dair bilgilerin bulunması zorunludur.{" "}
                    <br />
                    <br />
                    İlgili Kişi, yukarıda belirtilen hakları kullanmak için
                    yapacağı ve kullanmayı talep ettiği hakka ilişkin
                    açıklamaları içeren başvuruda talep edilen hususu açık ve
                    anlaşılır şekilde belirtmelidir. Başvuruya ilişkin bilgi ve
                    belgelerin başvuruya eklenmesi gerekmektedir.
                    <br />
                    <br />
                    Talep konusunun başvuranın şahsı ile ilgili olması
                    gerekmekle birlikte, başkası adına hareket ediliyor ise
                    başvuruyu yapanın bu konuda özel olarak yetkili olması ve bu
                    yetkinin belgelendirilmesi (vekâletname) gerekmektedir.
                    Ayrıca başvurunun kimlik ve adres bilgilerini içermesi ve
                    başvuruya kimliği doğrulayıcı belgelerin eklenmesi
                    gerekmektedir. <br />
                    <br />
                    Yetkisiz üçüncü kişilerin başkası adına yaptığı talepler
                    değerlendirmeye alınmayacaktır.
                  </p>

                  <li className="font-semibold ml-10">
                    Kişisel Verilerinizin İşlenmesine İlişkin Talepleriniz Ne
                    Kadar Sürede Cevaplanır?
                  </li>

                  <p>
                    Kişisel verilerinize ilişkin talepleriniz değerlendirilerek,
                    Ray Sigorta’ya ulaştığı tarihten itibaren en kısa sürede ve
                    en geç 30 gün içinde cevaplandırılır. Talebinizin kabul
                    edilmesi veya gerekçesi açıklanarak reddedilmesi halinde
                    cevabımız başvuruda belirttiğiniz adrese posta veya
                    elektronik posta yolu başta olmak üzere eğer mümkünse
                    talebinizin yapıldığı usulle size iletilir.
                  </p>
                </ul>
              </div>
            </div>
            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                className="px-4 py-2 mr-2 bg-custom-red text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-600 hover:shadow-lg focus:bg-red-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-600 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Kapat
              </button>
              <label
                htmlFor={!props.isChecked ? "aydinlatma-metni" : ""}
                data-bs-dismiss="modal"
                className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
              >
                Onaylıyorum
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AydinlatmaMetni;
